import _ from 'lodash';

/*
When make changes, update SharedModels.Models.Business.EnumUserPermission enum as well
Also update store/slice/user/getUserPermissions reducer if needed
*/
export const UserRolePermissions = {
  canViewPages: 0,
  canBook: 1,
  canHold: 2,
  canSendEmailQuote: 3,
  canRequestAdvisor: 4,
  canSendCompare: 5,
  canSendBrochure: 6,
  canBookFromTripQuote: 7,
  canDeletePaymentMethod: 8,
  canSetDefaultPaymentMethod: 9,
  canSavePaymentMethod: 10,
  canChargeAgencyPlanningFees: 11,
  showHotelRateCodes: 12,
  showCarRateCodes: 13,
  showFlightRateCodes: 14,
  canOverrideDkNumber: 15,
  canSplitAgencyPlanningFees: 16,
  canViewOtherAgentsBookedTrips: 17,
  canUnverifiedUserAccessSite: 18,
  canOverrideIATANumber: 19,
  canCancelBooking: 20,
  canChangeBooking: 21,
};

export const DO_USE_VGS_INPUT_FORM = true;
export const CRUISE_PAY_SCHEDULE_FINAL_PAY = 'FINAL';
export const CRUISE_PAY_SCHEDULE_DEPOSIT = 'DEPOSIT';
export const PROMO_CODE_MAX_CHARS = 20;
export const TIPS_HUB = '/hubs/tips';
export const HOTELS_HUB = '/hubs/hotels';
export const FLIGHTS_HUB = '/hubs/flights';
export const BOOKING_FEES_LABEL = 'Booking Fees';

export const ERROR_CODES = {
  AGENCY_MISMATCH: 'AGENCY_MISMATCH',
};

export const RefundTypes = {
  FullyRefundable: 0,
  NonRefundable: 1,
  PartialRefundable: 2,
};

export const TripConfirmationChanges = {
  Payment: 0,
  Insurance: 1,
  Packages: 2,
  SpecialServices: 3,
  CruiseTransport: 4,
  Dining: 5,
};

export const SearchStatus = {
  INITIAL: 0,
  SEARCHING: 1,
  DONE: 2,
  ERROR: 3,
};

export const BookingAction = {
  BOOK: 0,
  HOLD: 1,
  SEND_QUOTE: 2,
  CANCELLED: 3,
  BROCHURE: 4,
  ADVICE: 5,
  REQUEST_TO_BOOK: 6,
  COMPARE: 7,
};

export const CruisePayment = {
  DEPOSIT_EXISTS: true,
  FINAL_PAYMENT: true,
};

export const TravelTypes = {
  flight: 0,
  drive: 1,
  walk: 2,
  uber: 3,
  park: 4,
  hotel: 5,
  vacationrental: 6,
  taxi: 7,
  shuttle: 8,
  train: 9,
  carrental: 10,
  bus: 11,
  meeting: 12,
  dummy: 13,
  transit: 14,
  cruise: 15,
  custom: 16,
  tour: 17,
};

// NOTE: if making any changes, look into SharedModels.Models.TripServices.CreditCardPayment
// .CastToBillingInformation() require update or not
// Also, update supportedCreditCards
export const CreditCardCodes = {
  Amex: 'AX',
  DinersClub: 'DC',
  Discover: 'DS',
  Empty: '',
  JCB: 'JC',
  MasterCard: 'MC',
  Visa: 'VI',
  UnionPay: 'CU',
};

export const Duration = [
  {
    label: 'Any duration', value: 0, from: null, to: null,
  },
  {
    label: '1 - 2 nights', value: 1, from: 1, to: 2,
  },
  {
    label: '3 - 5 nights', value: 2, from: 3, to: 5,
  },
  {
    label: '6 - 8 nights', value: 3, from: 6, to: 8,
  },
  {
    label: '9 - 11 nights', value: 4, from: 9, to: 11,
  },
  {
    label: '12+ nights', value: 5, from: 12, to: null,
  },
  {
    label: 'Custom duration', value: 6, from: 1, to: null,
  },
];

export const DurationRange = {
  min: 1,
  max: 32,
};

// this enum is from backend API - MUST correspond!
export const CabinType = {
  INSIDE: 0,
  OCEANVIEW: 1,
  BALCONY: 2,
  SUITE: 3,
};

export const CabinTypes = ['Inside Cabin', 'Ocean View', 'Balcony', 'Suite'];

export const CabinTypeLabel = (() => {
  const labels = {};
  labels[CabinType.INSIDE] = 'Interior';
  labels[CabinType.OCEANVIEW] = 'Oceanview';
  labels[CabinType.BALCONY] = 'Balcony';
  labels[CabinType.SUITE] = 'Suite';

  return labels;
})();

export const AgencyPlanningType = {
  AgencyPlanningFeesPerTrip: 18,
  AgencyPlanningFeesPerPassenger: 34,
};

export const AgencyPlanningTypeLabel = [
  { value: AgencyPlanningType.AgencyPlanningFeesPerTrip, label: 'Per PNR' },
  { value: AgencyPlanningType.AgencyPlanningFeesPerPassenger, label: 'Per Passenger' },
];

export const CabinTypeFilterValues = [
  { value: CabinType.INSIDE, label: 'Interior' },
  { value: CabinType.OCEANVIEW, label: 'Oceanview' },
  { value: CabinType.BALCONY, label: 'Balcony' },
  { value: CabinType.SUITE, label: 'Suite' },
];

export const FlightStopsFilterValues = {
  ANY: { value: null, label: 'Any number of stops' },
  NONSTOP: { value: 0, label: 'Non-stop only' },
  ONESTOP: { value: 1, label: 'One stops or fewer' },
  TWOSTOP: { value: 2, label: 'Two stops or fewer' },
};

export const PortOfDepartureOption = {
  ANY: 0,
  NONSTOP: 1,
  US: 2,
  SPECIFIC: 3,
};

export const PortOfDepartureLabel = (() => {
  const labels = {};
  labels[PortOfDepartureOption.ANY] = 'Any port';
  labels[PortOfDepartureOption.NONSTOP] = 'Any port with nonstop flights from ';
  labels[PortOfDepartureOption.US] = 'US only';
  labels[PortOfDepartureOption.SPECIFIC] = 'Specific ports';

  return labels;
})();

export const DiscountEligibility = {
  SENIOR: 0,
  MILITARY: 1,
  PROFESSIONAL: 2,
  AMEX_MEMBER: 3,
  PAST_PASSENGER: 4,
  OCCUPATION: 5,
  FLEX_MEMBERSHIP_REWARDS: 6,
  IS_VIRTUOSO_SAILINGS: 7,
  HAVE_VIRTUOSO_VOYAGES_PROMO: 8,
};

export const DiscountOptions = {
  [DiscountEligibility.SENIOR]: {
    name: 'senior',
    value: DiscountEligibility.SENIOR,
    label: 'Senior discount',
  },
  [DiscountEligibility.MILITARY]: {
    name: 'military',
    value: DiscountEligibility.MILITARY,
    label: 'Military discount',
  },
  [DiscountEligibility.PROFESSIONAL]: {
    name: 'professional',
    value: DiscountEligibility.PROFESSIONAL,
    label: 'Travel industry professional',
  },
  [DiscountEligibility.AMEX_MEMBER]: {
    name: 'amexMember',
    value: DiscountEligibility.AMEX_MEMBER,
    label: 'Show ACG sailings only',
  },
  [DiscountEligibility.IS_VIRTUOSO_SAILINGS]: {
    name: 'showVirtuosoVoyages',
    value: DiscountEligibility.IS_VIRTUOSO_SAILINGS,
    label: 'Show Virtuoso Voyages',
  },
  [DiscountEligibility.HAVE_VIRTUOSO_VOYAGES_PROMO]: {
    name: 'showVirtuosoVoyagesPromo',
    value: DiscountEligibility.HAVE_VIRTUOSO_VOYAGES_PROMO,
    label: 'Virtuoso Voyages Promotions',
  },
  [DiscountEligibility.PAST_PASSENGER]: {
    name: 'pastPassenger',
    value: DiscountEligibility.PAST_PASSENGER,
    label: 'Past passenger',
  },
  [DiscountEligibility.OCCUPATION]: {
    name: 'occupation',
    value: DiscountEligibility.OCCUPATION,
    label: 'Occupation',
  },
  [DiscountEligibility.FLEX_MEMBERSHIP_REWARDS]: {
    name: 'Flex Membership Rewards',
    value: DiscountEligibility.FLEX_MEMBERSHIP_REWARDS,
    label: 'Show sailings with Flex Membership Rewards Promotions',
  },
};

export const DiscountFilterValues = [
  // TODO: implement all these discounts, for now commented out
  // { value: DiscountEligibility.SENIOR, label: 'Senior' },
  // { value: DiscountEligibility.MILITARY, label: 'Military' },
  // { value: DiscountEligibility.PROFESSIONAL, label: 'Travel industry professional' },
  { value: DiscountEligibility.AMEX_MEMBER, label: 'Show ACG sailings only', isAMEX: true },
  { value: DiscountEligibility.FLEX_MEMBERSHIP_REWARDS, label: 'Show sailings with Flex Membership Rewards Promotions', isAMEX: true },
  { value: DiscountEligibility.IS_VIRTUOSO_SAILINGS, label: 'Show Virtuoso Voyages', isVirtuoso: true },
  { value: DiscountEligibility.HAVE_VIRTUOSO_VOYAGES_PROMO, label: 'Show sailings with Virtuoso Voyages Promotions', isVirtuoso: true },
  { value: DiscountEligibility.PAST_PASSENGER, label: 'Past passenger', doInputForEachRoom: true },
  { value: DiscountEligibility.OCCUPATION, label: 'Occupation', doInputForEachRoom: true },
];

export const DiscountEligibilityLabel = (() => {
  const labels = {};
  labels[DiscountEligibility.SENIOR] = 'Senior';
  labels[DiscountEligibility.MILITARY] = 'Military';
  labels[DiscountEligibility.PROFESSIONAL] = 'Professional';
  labels[DiscountEligibility.AMEX_MEMBER] = 'Show ACG sailings only';
  labels[DiscountEligibility.IS_VIRTUOSO_SAILINGS] = 'Show virtuoso ';
  labels[DiscountEligibility.HAVE_VIRTUOSO_VOYAGES_PROMO] = 'Show sailings with Virtuoso Voyages Promotions';
  labels[DiscountEligibility.FLEX_MEMBERSHIP_REWARDS] = 'Show sailings with Flex Membership Rewards Promotions';
  labels[DiscountEligibility.PAST_PASSENGER] = 'Past passenger';
  labels[DiscountEligibility.OCCUPATION] = 'Occupation';

  return labels;
})();

export const checkDoSearchDeepLinkWithoutDate = (obj, doAllowDeepLinkWithoutDate) => (
  !obj.checkInDate && !obj.checkOutDate && obj['sa[hotelId]'] && doAllowDeepLinkWithoutDate
);
// When make any changes update backend cruises_backend\SharedModels\Models\Enums\TransportMode.cs
export const SearchModes = {
  CRUISE_TRIP: '0',
  FLIGHT: '1',
  HOTEL: '2',
  CAR: '3',
  CUSTOM: '4',
  TOUR: '5',
};
export const airlinesOptions = [
  { value: 0, label: 'Include' },
  { value: 1, label: 'Only' },
  { value: 2, label: 'Exclude' },
];

export const onlyAirlineOption = [
  { value: 1, label: 'Only' },
];
export const connectingAirportsOptions = [
  { value: 0, label: 'Only' },
  { value: 1, label: 'Exclude' },
];
export const onlyAllianceOption = [
  { value: 0, label: 'Include' },
];
export const allianceOptions = [
  { value: 0, label: 'Include' },
  { value: 1, label: 'Exclude' },
];

export const allianceAutoComplete = [
  { value: '*A', label: 'Star Alliance' },
  { value: '*O', label: 'OneWorld' },
  { value: '*S', label: 'Sky Team' },
];

export const UserRoles = {
  ADMIN: 0,
  AGENT: 1,
  CUSTOMER: 2,
  SUPER_ADMIN: 3,
};

export const CurrencyDropdownVariant = {
  DEFAULT: '0',
  WITHOUT_BG_BORDER: '1',
  WITHOUT_BG_BORDER_WITH_RIGHT_BORDER: '2',
};

export const TwAttributionVariants = {
  DEFAULT: '0',
  LOGO_CENTER: '1',
  BELOW_AGENCY_LOGO: '2',
  UNDER_SEARCH_BAR: '3',
};

export const SearchModeLabel = {
  [SearchModes.CRUISE_TRIP]: 'Cruises',
  [SearchModes.FLIGHT]: 'Flights',
  [SearchModes.HOTEL]: 'Hotels',
  [SearchModes.CAR]: 'Cars',
  [SearchModes.CUSTOM]: 'TripKits',
  [SearchModes.TOUR]: 'Tours',
};

export const AvailableChildrenAges = [
  {
    label: '2 years', value: 2,
  },
  {
    label: '3 years', value: 3,
  },
  {
    label: '4 years', value: 4,
  },
  {
    label: '5 years', value: 5,
  },
  {
    label: '6 years', value: 6,
  },
  {
    label: '7 years', value: 7,
  },
  {
    label: '8 years', value: 8,
  },
  {
    label: '9 years', value: 9,
  },
  {
    label: '10 years', value: 10,
  },
  {
    label: '11 years', value: 11,
  },
];

export const HotelRatings = {
  ANY: null,
  ONESTAR: 1,
  TWOSTAR: 2,
  THREESTAR: 3,
  FOURSTAR: 4,
  FIVESTAR: 5,
};

export const HotelRatingFilterOptions = [
  { value: HotelRatings.ANY, label: 'Any star rating' },
  { value: HotelRatings.ONESTAR, label: '1+ star' },
  { value: HotelRatings.TWOSTAR, label: '2+ stars' },
  { value: HotelRatings.THREESTAR, label: '3+ stars' },
  { value: HotelRatings.FOURSTAR, label: '4+ stars' },
  { value: HotelRatings.FIVESTAR, label: '5+ stars' },
];

export const getAutocompleteType = ({ doPrioritizeHotelsOnAutoCompleteResults = false } = {}) => ({
  AIRPORTS: [3],
  FLIGHT_ORIGIN: [4],
  FLIGHT_DESTINATION: [4],
  CRUISE_LINES: [7],
  CRUISE_SHIPS: [6],
  PORT_OF_DEPARTURE: [5],
  DESTINATIONS: [1],
  PASSENGER_CITIES: [8],
  HOTELS: doPrioritizeHotelsOnAutoCompleteResults ? [10, 9] : [9, 10],
  CUSTOM: [11],
  ADDRESSES: [9],
  AIRLINES: [12],
});
export const AutocompleteType = getAutocompleteType();

export const Staterooms = {
  type: 'staterooms',
  label: 'Staterooms',
};

export const Rooms = {
  type: 'rooms',
  label: 'Rooms',
};

export const getSearchModesByAgency = (enabledTransportModes) => {
  if (enabledTransportModes && enabledTransportModes.length) {
    const m = Object.values(SearchModes);
    return _.filter(
      m,
      (s) => enabledTransportModes.indexOf(+s) > -1,
    );
  }
  return Object.values(SearchModes);
};

export const PassengerTypes = {
  adults: {
    type: 'adults', label: 'Adults', helperText: '(Ages 12–54 at time of travel)', text: 'Adult', fromAge: 12, toAge: 54, ignoreValidateToAge: true,
  },
  seniors: {
    type: 'seniors', label: 'Seniors', helperText: '(Ages 55 and above at time of travel)', text: 'Senior', fromAge: 55,
  },
  children: {
    type: 'children', label: 'Children', helperText: '(Ages 2–11 at time of travel)', text: 'Child', fromAge: 2, toAge: 11,
  },
  lapInfants: {
    type: 'lapInfants', label: 'Infants', helperText: '(On lap – under 2 years at time of travel)', text: 'Infant on lap', toAge: 1,
  },
  seatInfants: {
    type: 'seatInfants', label: 'Infants', helperText: '(In seat – under 2 years at time of travel)', text: 'Infant in seat', toAge: 1,
  },
};

export const GetPassengerTypes = (enabledTransportModes, selectedSearchMode) => {
  const enabledModes = getSearchModesByAgency(enabledTransportModes);

  const hasOnlyHotelMode = _.isEqual(_.intersection(
    enabledModes,
    [SearchModes.HOTEL],
  ), [SearchModes.HOTEL]);

  const hasOnlyCarMode = _.isEqual(_.intersection(
    enabledModes,
    [SearchModes.CAR],
  ), [SearchModes.CAR]);

  if ((enabledModes.includes(SearchModes.HOTEL) || enabledModes.includes(SearchModes.CAR))
    && (selectedSearchMode === SearchModes.HOTEL || selectedSearchMode === SearchModes.CAR)) {
    return {
      adults: {
        ...PassengerTypes.adults, label: 'Guests', text: 'Guest', helperText: '', fromAge: 18, toAge: undefined,
      },
    };
  }
  // If cruise enabled but flight not enabled, don't take lap/seat infants
  if (!enabledModes.includes(SearchModes.FLIGHT)
  && enabledModes.includes(SearchModes.CRUISE_TRIP)) {
    let updatedPassengerTypes = _.omit(PassengerTypes, ['lapInfants', 'seatInfants']);
    updatedPassengerTypes = _.mapValues(updatedPassengerTypes, (passengerType, key) => {
      if (key === 'children') {
        return {
          ...passengerType,
          helperText: 'Aged 0 to 11',
          fromAge: 0,
        };
      }
      return passengerType;
    });
    return updatedPassengerTypes;
  }

  // If flight enabled but cruise not enabled, don't take seniors
  if (enabledModes.includes(SearchModes.FLIGHT)
  && (!enabledModes.includes(SearchModes.CRUISE_TRIP)
|| selectedSearchMode === SearchModes.FLIGHT)) {
    let updatedPassengerTypes = _.omit(PassengerTypes, ['seniors']);
    updatedPassengerTypes = _.mapValues(updatedPassengerTypes, (passengerType, key) => {
      if (key === 'adults') {
        return {
          ...passengerType,
          helperText: 'Ages 12 and above',
          toAge: undefined,
        };
      }
      return passengerType;
    });
    return updatedPassengerTypes;
  }

  if (enabledModes.includes(SearchModes.FLIGHT)) {
    if (selectedSearchMode !== SearchModes.CRUISE_TRIP) return PassengerTypes;
    return _.mapValues(
      _.omit(PassengerTypes, ['seatInfants']),
      (passengerType, key) => (key === 'lapInfants' ? { ...passengerType, helperText: '' } : passengerType),
    );
  } if (enabledModes.includes(SearchModes.CRUISE_TRIP)) {
    return {
      adults: {
        ...PassengerTypes.adults, helperText: 'Ages 18 - 54', fromAge: 18, toAge: 54,
      },
      seniors: { ...PassengerTypes.seniors },
      children: {
        ...PassengerTypes.children, helperText: 'Aged 0 to 17', fromAge: 0, toAge: 17,
      },
    };
  } if (hasOnlyHotelMode || hasOnlyCarMode || (hasOnlyCarMode && hasOnlyHotelMode)) {
    return {
      adults: {
        ...PassengerTypes.adults, label: 'Guests', text: 'Guest', helperText: '', fromAge: 18, toAge: undefined,
      },
    };
  }

  return {
    adults: {
      ...PassengerTypes.adults, helperText: '', fromAge: 18, toAge: undefined,
    },
    children: {
      ...PassengerTypes.children, helperText: 'Aged 0 to 17', fromAge: 0, toAge: 17,
    },
  };
};

export const DurationTypes = [
  { type: 'from', label: 'From (nights)' },
  { type: 'to', label: 'To (nights)' },
];

export const StopType = {
  ANY: null,
  NONSTOP: 0,
  ONESTOP: 1,
  TWOSTOPS: 2,
};

export const StopFilterOptions = [
  { value: StopType.ANY, label: 'Any number of stops' },
  { value: StopType.NONSTOP, label: 'Non-stop only' },
  { value: StopType.ONESTOP, label: '1 stop or fewer' },
  { value: StopType.TWOSTOPS, label: '2 stops or fewer' },
];

export const FlightFiltersOptions = [
  {
    type: 'flightOrigin',
    autocompleteType: AutocompleteType.FLIGHT_ORIGIN,
    autocompleteResultsType: 'flightOriginAutocompleteResults',
    selectedItemName: 'origin',
    trackEventName: 'fromFlightFilter',
  },
  {
    type: 'flightDestination',
    autocompleteType: AutocompleteType.FLIGHT_DESTINATION,
    autocompleteResultsType: ' airportAutocompleteResults',
    selectedItemName: 'destination',
    trackEventName: 'toFlightFilter',
  },
];

export const minLayoverDuration = 0;
export const maxLayoverDuration = 1439;

export const ListPageSize = 10;
export const InfoPageSize = 3;

export const CarUISearchType = {
  ENTIREDURATION: 0,
  BEFOREANDAFTERCRUISE: 1,
};

export const CarUISearchTypeOptions = [
  { value: CarUISearchType.ENTIREDURATION, label: 'Same Drop-off' },
  { value: CarUISearchType.BEFOREANDAFTERCRUISE, label: 'Different Drop-off' },
];

/*
If any changes, update cruises_backend/SharedModels/Models/Enums/HotelRateDisplayPreferences.cs
*/

export const RoomCategoryFilters = ['AAA', 'SENIOR', 'MILITARY', 'GOVERNMENT', 'GOVT', 'AARP',
  'AMERICAN AUTO ASSOC', 'AMERICAN AUTOMOBILE ASSOCIATION'];

export const HotelRateDisplayPreferences = {
  TotalRate: 0,
  NightlyPrice: 1,
  NightlyTotalWithoutTax: 2,
};

export const HotelRateDisplayPreferenceLabels = {
  [HotelRateDisplayPreferences.TotalRate]: { label: 'Stay Total', description: 'Total price with taxes + fees' },
  [HotelRateDisplayPreferences.NightlyPrice]: { label: 'Nightly total', description: 'Nightly price with taxes + fees' },
  [HotelRateDisplayPreferences.NightlyTotalWithoutTax]: { label: 'Nightly price', description: 'Nightly price excluding taxes + fees' },
};

export const FlightSearchTypes = {
  ROUND_TRIP: 0,
  MULTI_CITY: 1,
  ONE_WAY: 2,
  DIRECT_SELL: 3,
};

export const getSupportedParams = (supportedUrlParams, router) => {
  if (!supportedUrlParams || !router || !router.query) {
    return {};
  }
  const supportedParamsArray = supportedUrlParams.split(',').map((param) => param.trim().toLowerCase());
  const filteredRouter = Object.entries(router.query)
    .filter(([key]) => supportedParamsArray.includes(key.toLowerCase()));

  const query = {};

  filteredRouter.forEach(([key, val]) => {
    const lowerCaseKey = key.toLowerCase();
    if (query[lowerCaseKey]) {
      query[lowerCaseKey] = [...query[lowerCaseKey], ...(_.isArray(val) ? val : [val])];
    } else {
      query[lowerCaseKey] = _.isArray(val) ? val : [val];
    }
    query[lowerCaseKey] = _.filter(query[lowerCaseKey], (f) => f && f.length);
    if (!query[lowerCaseKey] || !query[lowerCaseKey].length) {
      delete query[lowerCaseKey];
    }
  });
  return query;
};

export const FlightSearchTypeOptions = {
  [FlightSearchTypes.ONE_WAY]: { value: FlightSearchTypes.ONE_WAY, label: 'One-way', icon: '' },
  [FlightSearchTypes.ROUND_TRIP]: { value: FlightSearchTypes.ROUND_TRIP, label: 'Round-trip', icon: '' },
  [FlightSearchTypes.MULTI_CITY]: { value: FlightSearchTypes.MULTI_CITY, label: 'Multi-city', icon: '' },
  [FlightSearchTypes.DIRECT_SELL]: { value: FlightSearchTypes.DIRECT_SELL, label: 'Direct-sell (beta)', icon: '' },
};

export const CruiseSortType = {
  BEST: 0,
  DEPARTURE_DATE: 1,
  RETURN_DATE: 2,
  INSIDE: 3,
  OCEAN_VIEW: 4,
  BALCONY: 5,
  SUITE: 6,
  LENGTH_OF_CRUISE: 7,
};

export const CruiseSortValues = [
  // { value: CruiseSortType.BEST, label: 'Best' },
  { value: CruiseSortType.INSIDE, label: 'Inside price' },
  { value: CruiseSortType.OCEAN_VIEW, label: 'Oceanview price' },
  { value: CruiseSortType.BALCONY, label: 'Balcony price' },
  { value: CruiseSortType.SUITE, label: 'Suite price' },
  { value: CruiseSortType.DEPARTURE_DATE, label: 'Departure date' },
  { value: CruiseSortType.RETURN_DATE, label: 'Return date' },
  { value: CruiseSortType.LENGTH_OF_CRUISE, label: 'Trip length' },
];

export const SortDirection = {
  ASCEND: 0,
  DESCEND: 1,
};

export const HotelSortingType = {
  PRICE: 0,
  BEST: 1,
  STAR_RATING: 2,
  DISTANCE_TO_CRUISE_PORT: 3,
  DISTANCE_FROM_SEARCH_LOCATION: 4,
  HOTEL_CHAIN: 5,
};

export const FlightSortingType = {
  BEST: 0,
  PRICE: 1,
  OUTBOUND_DURATION: 2,
  INBOUND_DURATION: 3,
  STOPS: 4,
};
export const CarRentalSortingType = {
  BEST: 0,
  PRICE: 1,
};
export const HotelSortingValues = [
  { value: HotelSortingType.PRICE, label: 'Price' },
  { value: HotelSortingType.BEST, label: 'Best' },
  { value: HotelSortingType.STAR_RATING, label: 'Rating' },
  { value: HotelSortingType.HOTEL_CHAIN, label: 'Hotel chain' },
  { value: HotelSortingType.DISTANCE_TO_CRUISE_PORT, label: 'Distance to cruise port' },
  { value: HotelSortingType.DISTANCE_FROM_SEARCH_LOCATION, label: 'Distance from search location' },
];

export const FlightSortingValues = [
  { value: FlightSortingType.BEST, label: 'Best' },
  { value: FlightSortingType.PRICE, label: 'Price' },
  { value: FlightSortingType.OUTBOUND_DURATION, label: 'Outbound duration' },
  { value: FlightSortingType.INBOUND_DURATION, label: 'Inbound duration' },
  { value: FlightSortingType.STOPS, label: 'Stops' },
];

export const CarRentalSortingValues = [
  { value: CarRentalSortingType.BEST, label: 'Best' },
  { value: CarRentalSortingType.PRICE, label: 'Price' },
];
export const CustomItinerarySortingType = {
  PRICE: 0,
};

export const CustomItinerarySortingValues = [
  { value: CustomItinerarySortingType.PRICE, label: 'Price' },
];

export const TripsSortingType = {
  RECENT: 0,
  TRIP_START_DATE: 1,
};

export const TripsSortingValues = [
  { value: TripsSortingType.RECENT, label: 'Recent' },
  { value: TripsSortingType.TRIP_START_DATE, label: 'Trip start date' },
];

export const CheckoutFieldPlacement = {
  PrimaryPassenger: 'PrimaryPassenger',
  AdditionalDetailsSection: 'AdditionalDetailsSection',
};

export const PassengerOccupations = [
  {
    value: 'MIL',
    name: 'Military',
  },
  {
    value: 'ACC',
    name: 'Accountant',
  },
  {
    value: 'ADM',
    name: 'Administration',
  },
  {
    value: 'APR',
    name: 'Appraiser',
  },
  {
    value: 'ARC',
    name: 'Architect',
  },
  {
    value: 'ART',
    name: 'Artist',
  },
  {
    value: 'LAW',
    name: 'Attorney',
  },
  {
    value: 'CAP',
    name: 'Banker',
  },
  {
    value: 'BUS',
    name: 'Business owner',
  },
  {
    value: 'CAR',
    name: 'Caretaker',
  },
  {
    value: 'CAS',
    name: 'Cashier',
  },
  {
    value: 'CFO',
    name: 'Chief fin off',
  },
  {
    value: 'CHD',
    name: 'Child',
  },
  {
    value: 'CIV',
    name: 'Civil services',
  },
  {
    value: 'CLK',
    name: 'Clerk',
  },
  {
    value: 'COL',
    name: 'Collectivos',
  },
  {
    value: 'BLD',
    name: 'Construction',
  },
  {
    value: 'CON',
    name: 'Consultant',
  },
  {
    value: 'DOC',
    name: 'Doctor',
  },
  {
    value: 'DRV',
    name: 'Driver',
  },
  {
    value: 'ENG',
    name: 'Engineer',
  },
  {
    value: 'ENT',
    name: 'Entertainer',
  },
  {
    value: 'FAR',
    name: 'Farmer',
  },
  {
    value: 'FIN',
    name: 'Fin director',
  },
  {
    value: 'FMN',
    name: 'Fire fighter',
  },
  {
    value: 'GVT',
    name: 'Government',
  },
  {
    value: 'HMK',
    name: 'Homemaker',
  },
  {
    value: 'HOS',
    name: 'Hospital admin',
  },
  {
    value: 'HTL',
    name: 'Hotel svc',
  },
  {
    value: 'INS',
    name: 'Ins industry',
  },
  {
    value: 'INV',
    name: 'Investor',
  },
  {
    value: 'JDG',
    name: 'Judge',
  },
  {
    value: 'LAB',
    name: 'Laborer',
  },
  {
    value: 'LAN',
    name: 'Land owner',
  },
  {
    value: 'MED',
    name: 'Medical',
  },
  {
    value: 'MDT',
    name: 'Medical tech',
  },
  {
    value: 'MER',
    name: 'Merchant',
  },
  {
    value: 'NUR',
    name: 'Nurse',
  },
  {
    value: 'OFA',
    name: 'Office admin',
  },
  {
    value: 'OFF',
    name: 'Office worker',
  },
  {
    value: 'PRS',
    name: 'Personal',
  },
  {
    value: 'PIL',
    name: 'Pilot',
  },
  {
    value: 'COP',
    name: 'Police officer',
  },
  {
    value: 'PRI',
    name: 'Priest',
  },
  {
    value: 'PAL',
    name: 'Principal',
  },
  {
    value: 'PRF',
    name: 'Professional',
  },
  {
    value: 'PRO',
    name: 'Professor',
  },
  {
    value: 'PSY',
    name: 'Psychologist',
  },
  {
    value: 'RBI',
    name: 'Rabbi',
  },
  {
    value: 'RLS',
    name: 'Real est broker',
  },
  {
    value: 'REA',
    name: 'Real estate mgr',
  },
  {
    value: 'RTS',
    name: 'Retail sales',
  },
  {
    value: 'RET',
    name: 'Retired',
  },
  {
    value: 'SCI',
    name: 'Scientist',
  },
  {
    value: 'SEC',
    name: 'Secretary',
  },
  {
    value: 'STK',
    name: 'Stock broker',
  },
  {
    value: 'STO',
    name: 'Store owner',
  },
  {
    value: 'STD',
    name: 'Student',
  },
  {
    value: 'TAI',
    name: 'Tailor',
  },
  {
    value: 'TEA',
    name: 'Teacher',
  },
  {
    value: 'TCN',
    name: 'Technical',
  },
  {
    value: 'TEC',
    name: 'Technician',
  },
  {
    value: 'TVL',
    name: 'Travel agent',
  },
  {
    value: 'TRV',
    name: 'Travel industry',
  },
  {
    value: 'WRI',
    name: 'Writer',
  },
];

export const defaultPassengerCity = {
  value: 'BUF',
  label: 'BUFFALO, NY, US',
};

export const defaultStateroomFilling = {
  adults: 2,
  seniors: 0,
  children: [],
  lapInfants: 0,
  seatInfants: 0,
  discounts: [],
  pastPassengerNumbers: [],
  passengerOccupation: '',
};

export const CreditCardNumberValidLength = [16];
export const CvcValidLength = 3;
export const ValidAgeForPrimaryPassenger = 18;
export const ValidAgeForPrimaryPassengerFlightOnly = 12;
export const MaxValidPhoneLength = 10;
export const MinValidPhoneLength = 9;

export const CruiseFilterInitialValue = {
  locations: [],
  duration: Duration[0],
  filters: {
    origin: null,
    city: null,
    cruiseLines: [],
    cruiseShips: [],
    cityIds: [],
    portOfDepartureOption: PortOfDepartureOption.ANY,
    cabinType: CabinType.INSIDE,
    discounts: [],
  },
};

export const CruisePageSettingsInitialValue = {
  page: 1,
  pageSize: ListPageSize,
  sortBy: CruiseSortType.INSIDE,
  sortDirection: SortDirection.ASCEND,
};

export const HotelPageSettingsInitialValue = {
  page: 1,
  pageSize: ListPageSize,
  sortBy: HotelSortingType.BEST,
  sortDirection: SortDirection.ASCEND,
};

export const FlightPageSettingsInitialValue = {
  page: 1,
  pageSize: ListPageSize,
  sortBy: FlightSortingType.BEST,
  sortDirection: SortDirection.ASCEND,
};

export const CarPageSettingsInitialValue = {
  page: 1,
  pageSize: ListPageSize,
};

export const TourPageSettingsInitialValue = {
  page: 1,
  pageSize: ListPageSize,
};

export const CustomInventoryPageSettingsInitialValue = {
  page: 1,
  pageSize: ListPageSize,
};

export const CruiseInitialValue = {
  searchObj: {
    ...CruisePageSettingsInitialValue,
    ...CruiseFilterInitialValue,
  },
  searchFilter: {
    ...CruisePageSettingsInitialValue,
    ...CruiseFilterInitialValue,
    areFiltersEmpty: true,
  },
};

export const CruiseQueryStringFilterKeys = [
  'duration',
  'locations',
  'filters',
  'fromDate',
  'toDate',
  'staterooms',
];

export const TourQueryStringFilterKeys = [
  'startDate',
  'endDate',
  'destinations',
  'staterooms',
  'origin',
  'searchMode',
];

export const CustomInventoryQueryStringFilterKeys = [
  'startDate',
  'endDate',
  'destinations',
  'staterooms',
  'origin',
  'searchMode',
];

export const HotelQueryStringFilterKeys = [
  'staterooms',
  'doShowOnlyAgentPreferredHotels',
  'checkInDate',
  'checkOutDate',
  'selectedAddress',
  'sa',
  'filterRating',
  'origin',
  'rateCodes',
  'exactMatchRateCodesOnly',
  'hotelNames',
  'hotelChains',
  'fp',
  'tp',
  'doShowCommissionableRatesOnly',
  'showRefundableHotelRatesOnly',
  'showUnavailableHotels',
  'hproviders',
  'searchRadiuses',
];

export const FlightQueryStringFilterKeys = [
  'staterooms',
  'leaveDate',
  'returnDate',
  'maxNumOfStops',
  'keepSameCabin',
  'avoidCabinDowngrade',
  'fs',
  'fst',
  'airlines',
  'alliances',
  'rateCodes',
  'exactMatchRateCodesOnly',
  'diffCabins',
  'diffAirlines',
  'diffConnectingAirports',
  'diffAlliances',
  'flightSearchType',
  'doShowRefundableFlightsOnly',
  'doShowLongConnectFlights',
  'hideNDC',
  'doEnableFlightsPolling',
  'airlinesPreference',
  'alliancePreference',
];

export const CarQueryStringFilterKeys = [
  'staterooms',
  'carSearchType',
  'pickupCode',
  'dropoffCode',
  'pickupDateTime',
  'returnDateTime',
  'carTypes',
  'transmissionTypes',
  'rentalCarAgencies',
  'fromBudget',
  'toBudget',
  'origin',
  'rateCodes',
];

export const InitialFlightFilters = {
  filterStops: StopType.ANY,
  filterAirlines: [],
  takeoff: [],
  landing: [],
  filterTimeLayoverStart: null,
  filterTimeLayoverEnd: null,
  filterTakeoff: {},
  filterLanding: {},
};
export const FlightFilterType = {
  filterTakeOff: 0,
  filterLanding: 1,
};

export const MaximumFlightSegments = 6;

export const FiltersInitialValue = {
  cruise: CruiseInitialValue.searchObj,
  flight: {
    page: 1,
    sortBy: FlightSortingType.BEST,
    sortDirection: SortDirection.ASCEND,
    pageSize: InfoPageSize,
    flightSegments: [{}, {}],
    selectedFlightSegments: {},
    defaultSearchObj: {},
    flightSearchType: FlightSearchTypes.ROUND_TRIP,
    hasDifferentOutboundInboundCabins: false,
    hasDifferentOutboundInboundAirLine: false,
    hasDifferentOutboundInboundAlliance: false,
    hasDifferentOutboundInboundConnectingAirports: false,
    airlines: [],
    alliances: [],
    connectingAirports: [],
    maxNumOfStops: undefined,
    avoidCabinDowngrade: false,
    keepSameCabin: false,
    doHideNdcFares: undefined,
    airlinesPreference: undefined,
    alliancePreference: undefined,
    ...InitialFlightFilters,
    breadCrumbsIndex: 0,
  },
  hotel: {
    filterAmenities: [],
    filterHotelChains: [],
    filterHotelKeys: [],
    filterRating: HotelRatings.ANY,
    hotelProvidersToInclude: [],
    page: 1,
    pageSize: InfoPageSize,
    sortBy: HotelSortingType.BEST,
    sortDirection: SortDirection.ASCEND,
    doReturnHotelPins: true,
    doShowOnlyAgentPreferredHotels: false,
    doShowAvailableHotelsOnly: true,
    // placeId: null,
  },
  car: {
    carTypes: [],
    rentalCarAgencies: [],
    page: 1,
    pageSize: InfoPageSize,
    fromBudget: undefined,
    toBudget: undefined,
    // staterooms: [defaultStateroomFilling],
    pickupDateTime: null,
    returnDateTime: null,
    pickupCode: null,
    dropoffCode: null,
    carSearchType: CarUISearchType.ENTIREDURATION,
    sortBy: CarRentalSortingType.BEST,
    sortDirection: SortDirection.ASCEND,
  },
  customInventory: {
    startDate: undefined,
    endDate: undefined,
    destinations: undefined,
    staterooms: undefined,
    origin: undefined,
    page: 1,
    pageSize: InfoPageSize,
  },
};

export const NotNestedDropDownElement = 'dropdown-item__not-nested';

export const GENDER = {
  MALE: 'M',
  FEMALE: 'F',
  UNKNOWN_AT_THE_TIME_OF_BOOKING: 'U',
  UNSPECIFIED: 'X',
};

export const GenderList = [
  {
    value: GENDER.MALE,
    label: 'Male',
  },
  {
    value: GENDER.FEMALE,
    label: 'Female',
  },
];

const UnknownGenderList = [
  {
    value: GENDER.UNKNOWN_AT_THE_TIME_OF_BOOKING,
    label: 'Unknown at the time of booking',
  },
  {
    value: GENDER.UNSPECIFIED,
    label: 'Unspecified',
  },
];

export const FlightGenderList = [
  ...GenderList,
  ...UnknownGenderList,
];

export const FlightGenderListWithInfants = [
  {
    value: GENDER.MALE,
    label: 'Male infant',
  },
  {
    value: GENDER.FEMALE,
    label: 'Female infant',
  },
  ...UnknownGenderList,
];

export const DEFAULT_FEMALE_TITLE = 'MS';
export const DEFAULT_MALE_TITLE = 'MR';

export const Titles = [
  {
    value: 'ADML',
    label: 'Admiral',
    genderCode: 'B',
  },
  {
    value: 'BSHP',
    label: 'Bishop',
    genderCode: 'B',
  },
  {
    value: 'CAPT',
    label: 'Captain',
    genderCode: 'B',
  },
  {
    value: 'COL',
    label: 'Colonel',
    genderCode: 'B',
  },
  {
    value: 'CON',
    label: 'Congress',
    genderCode: 'B',
  },
  {
    value: 'DR',
    label: 'Doctor',
    genderCode: 'B',
  },
  {
    value: 'EARL',
    label: 'Earl',
    genderCode: 'M',
  },
  {
    value: 'FR',
    label: 'Father',
    genderCode: 'M',
  },
  {
    value: 'GEN',
    label: 'General',
    genderCode: 'B',
  },
  {
    value: 'GOV',
    label: 'Governor',
    genderCode: 'B',
  },
  {
    value: 'HON',
    label: 'Honorable',
    genderCode: 'B',
  },
  {
    value: 'LADY',
    label: 'Lady',
    genderCode: 'F',
  },
  {
    value: 'LORD',
    label: 'Lord',
    genderCode: 'M',
  },
  {
    value: 'MAJ',
    label: 'Major',
    genderCode: 'B',
  },
  {
    value: 'MSTR',
    label: 'Master',
    genderCode: 'M',
  },
  {
    value: 'MISS',
    label: 'Miss',
    genderCode: 'F',
  },
  {
    value: 'MSGR',
    label: 'Monsignor',
    genderCode: 'M',
  },
  {
    value: 'MR',
    label: 'Mr',
    genderCode: 'M',
  },
  {
    value: 'MRS',
    label: 'Mrs',
    genderCode: 'F',
  },
  {
    value: 'MS',
    label: 'Ms',
    genderCode: 'F',
  },
  {
    value: 'MX',
    label: 'Mx',
    genderCode: 'B',
  },
  {
    value: 'PROF',
    label: 'Professor',
    genderCode: 'B',
  },
  {
    value: 'RAB',
    label: 'Rabbi',
    genderCode: 'B',
  },
  {
    value: 'REV',
    label: 'Reverend',
    genderCode: 'B',
  },
  {
    value: 'SEN',
    label: 'Senator',
    genderCode: 'B',
  },
  {
    value: 'SIR',
    label: 'Sir',
    genderCode: 'M',
  },
  {
    value: 'SR',
    label: 'Sister',
    genderCode: 'F',
  },
];

export const CreditCardsFormValidation = {
  cardNumber: null,
  cardHolderName: null,
  expiration: null,
  cvc: null,
  addressLineOne: null,
  country: null,
  city: null,
  state: null,
  billingCode: null,
  selectedFor: null,
};

export const CreditCardsErrors = {
  cardNumber: 'Card number is required',
  cardHolderName: 'Card holder name is required',
  expiration: 'Expiration date is required',
  cvc: 'Security(CVC) code is required',
};

export const CreditCardsWithAddressErrors = {
  ...CreditCardsErrors,
  addressLineOne: 'Address is required',
  country: 'Country is required',
  city: 'City is required',
  billingCode: 'Billing code is required',
};

export const CardInitialState = {
  cardNumber: '',
  component: 'Empty',
  cardHolderName: '',
  expiration: '',
  cvc: '',
  addressLineOne: '',
  addressLineTwo: '',
  country: '',
  city: '',
  state: '',
  billingCode: '',
  isPicked: true,
  validCvcLength: CvcValidLength,
  validCardNumberLengths: CreditCardNumberValidLength,
  formValidations: CreditCardsFormValidation,
  doSaveCard: false,
  doSetAsDefault: false,
  selectedFor: [],
};

export const PassengerInfoFormValidation = {
  firstName: null,
  lastName: null,
  birthDate: null,
  phone: null,
  contactEmail: null,
  countryCode: null,
  address: null,
  postcode: null,
  emergencyContactPhoneNumber: null,
  emergencyContactContactEmail: null,
  issuingCountryCode: null,
  nationalityCountryCode: null,
  expirationDate: null,
  visaIssueDate: null,
  travelToCountryCode: null,
  visaDocumentNumber: null,
  passportDocumentNumber: null,
};

export const PassengerInfoValidations = ({
  pastPassengerNumber, doHoldOnlyCruiseAsOption, passengerIndexByRoom, travelAgency, isLoggedIn,
  itinerariesToBook, doUseTravelerInfoAsEmergencyContact,
}) => {
  const doAllowEmptyTravelerDetails = travelAgency
    && travelAgency.doAllowEmptyTravelerDetailsOnCruiseHold;
  const isHotelOnlyBooking = itinerariesToBook.length === 1
    && itinerariesToBook[0] === TravelTypes.hotel;
  const isRequiredForOnlyHotel = isHotelOnlyBooking && passengerIndexByRoom === 0;
  const isRequiredByDefault = !isHotelOnlyBooking && (!doAllowEmptyTravelerDetails
    || !doHoldOnlyCruiseAsOption || !isLoggedIn);
  const hasCruiseBooking = itinerariesToBook.some((type) => type === TravelTypes.cruise);

  /*
  RULES:
    When booking cruise/flight, all fields are required
    When only cruise only hold, contact email is only required
    When only hotel booking, primary contact first/last name and phone is required
  */
  return {
    firstName: pastPassengerNumber || isRequiredByDefault || isRequiredForOnlyHotel,
    middleName: undefined,
    lastName: pastPassengerNumber || isRequiredByDefault || isRequiredForOnlyHotel,
    birthDate: pastPassengerNumber || isRequiredByDefault,
    title: hasCruiseBooking ? isRequiredByDefault : undefined,
    gender: true, // pastPassengerNumber || isRequiredByDefault || isRequiredForOnlyHotel,
    countryCode: isRequiredByDefault,
    phone: doUseTravelerInfoAsEmergencyContact
      || (doHoldOnlyCruiseAsOption && doAllowEmptyTravelerDetails
        ? false : passengerIndexByRoom === 0),
    contactEmail: passengerIndexByRoom === 0 || doUseTravelerInfoAsEmergencyContact,
    postcode: hasCruiseBooking && passengerIndexByRoom === 0,
    address: hasCruiseBooking && passengerIndexByRoom === 0,
  };
};

export const PassengerInfoFormErrorsWhenPastPassenger = {
  firstName: 'First name is required because of past passenger',
  lastName: 'Last name is required because of past passenger',
  birthDate: 'Birth date is required because of past passenger',
  gender: 'Gender is required because of past passenger',
};

export const PassengerInfoFormErrors = {
  firstName: 'First name is required',
  lastName: 'Last name is required',
  birthDate: 'Valid birth date is required (Date format: MM/DD/YYYY or M/D/YYYY)',
  phone: 'Contact phone is required',
  contactEmail: 'Contact email is required',
  countryCode: 'Country is required',
  visaDocumentNumber: 'Document number is required (Min 3 - Max 24,Special characters not allowed)',
  passportDocumentNumber: 'Document number is required (Min 3 - Max 24,Special characters not allowed)',
  issuingCountryCode: 'Issuing country is required',
  nationalityCountryCode: 'National country is required',
  expirationDate: 'Issuing country is required',
  travelToCountryCode: 'Travel to country is required',
  postcode: 'Zip / Postal code is required',
  address: 'Address is required',
  gender: 'Gender is required',
};

export const PassengerDocumentNumberMinMaxLength = {
  minLength: 3,
  maxLength: 23,
};

export const SecurityInformationTypes = {
  PASSPORT_DOCS: 0,
  VISA_DOCO: 1,
  SELECT_APIS_TYPE: 2,
};

export const DOCSTypes = [
  { value: 'P', label: 'Passport' },
  { value: 'A', label: 'Alien resident card' },
  { value: 'C', label: 'Permanent resident card' },
  { value: 'I', label: 'National ID card' },
  { value: 'T', label: 'Refugee travel document and re-entry permit, US Travel document' },
  { value: 'F', label: 'Facilitation document' },
  { value: 'M', label: 'Military' },
  { value: 'N', label: 'Naturalization certificate' },
  { value: 'V', label: 'Border crossing card' },
];

export const PassengerDocumentInitialState = {
  apisType: SecurityInformationTypes.SELECT_APIS_TYPE,
  docsType: DOCSTypes[0].value,
  issuingCountryCode: undefined,
  nationalityCountryCode: undefined,
  documentNumber: '',
  expirationDate: undefined,
  visaIssueDate: undefined,
  travelToCountryCode: undefined,
  segments: [],
};

export const PassengerInitialState = {
  firstName: '',
  lastName: '',
  middleName: '',
  gender: 'M',
  title: 'MR',
  birthDate: null,
  phone: '',
  insuranceCoverage: false,
  phoneType: '',
  countryCode: 'US',
  stateProvCode: '',
  contactEmail: '',
  isPastPassenger: 0,
  pastPassengerNumber: null,
  doSendConfirmationEmail: false,
  formValidations: PassengerInfoFormValidation,
  roomIndex: 0,
  isPrimaryContact: false,
  travelerPreferences: {
    knownTravelerNumber: '',
    redressNumber: '',
    hotelLoyaltyNumbers: {},
    rentalCarLoyaltyNumbers: {},
    flightSeatNumbers: {},
    frequentFlyerNumbers: [],
    emergencyContact: {},
    advancePassengerInformations: [PassengerDocumentInitialState],
  },
};

export const PhoneTypes = [
  {
    value: 'mobile',
    label: 'Mobile',
  },
  {
    value: 'landline',
    label: 'Landline',
  },
];

export const transmissionTypes = [
  {
    value: '0',
    label: 'Manual',
  },
  {
    value: '1',
    label: 'Automatic',
  },
];

export const BookingStatus = {
  held: 'ON_HOLD',
  booked: 'CONFIRMED',
  cancelled: 'CANCELLED',
  pending: 'PENDING',
  failed: 'Failed',
};

export const LocationTypes = {
  AIRPORT: 'airports',
  PORT_OF_DEPARTURE: 'port_of_departure',
  ADDRESSES: 'addresses',
};

export const EnumMergedItineraryState = {
  ADDED: 0,
  UPDATED: 1,
};

export const cabinClassEnum = {
  BASIC_ECONOMY: 'Y-B',
  ECONOMY_MAIN_CABIN: 'Y-M',
  ECONOMY: 'Y',
  PREMIUM_ECONOMY: 'S',
  BUSINESS: 'C',
  PREMIUM_BUSINESS: 'J',
  FIRST: 'F',
  PREMIUM_FIRST: 'P',
};

export const FlightCabinsFilterValues = {
  '': 'Any',
  Y: 'Economy',
  S: 'Premium Economy',
  C: 'Business',
  J: 'Premium Business',
  F: 'First',
  P: 'Premium First',
};

export const NonStandardCabins = [
  cabinClassEnum.PREMIUM_BUSINESS,
  cabinClassEnum.PREMIUM_FIRST,
];

export const cabinClassRank = {
  '': -1,
  [cabinClassEnum.BASIC_ECONOMY]: 0,
  [cabinClassEnum.ECONOMY_MAIN_CABIN]: 1,
  [cabinClassEnum.ECONOMY]: 2,
  [cabinClassEnum.PREMIUM_ECONOMY]: 3,
  [cabinClassEnum.BUSINESS]: 4,
  [cabinClassEnum.PREMIUM_BUSINESS]: 5,
  [cabinClassEnum.FIRST]: 6,
  [cabinClassEnum.PREMIUM_FIRST]: 7,
};

export const ScrollStates = {
  SCROLLING: 'scrolling',
  DONE: 'done',
};

export const ProxyEndPoint = 'https://vault.travelwitsapi.com';

export const ProxyEndPointTest = 'https://tntb7qw7b8t.sandbox.verygoodproxy.com';
export const VGSVault = 'tntw2552drw';
export const VGSVaultTest = 'tntb7qw7b8t';
export const VGSVaultRouteId = '6f0f2001-813c-488d-b587-368c3298ff2e';
export const VGSVaultTestRouteId = '04dfe5ed-7c9a-4668-ad3d-f338dee093a0';
export const PricePerPersonDisclaimerTooltipText = 'Price per person, includes non-commissionable fare, does not include taxes and fees.';
export const RateOptionPriceDisclaimerTooltipText = 'Price is total, includes non-commissionable fare, does not include taxes and fees.';
export const BrochuresRateOptionPriceDisclaimerTooltipText = 'Price is total, does not include taxes and fees.';
export const BrochuresRateOptionTotalPriceDisclaimerTooltipText = 'Price is total amount, include taxes and fees.';

export const googleApiKey = 'AIzaSyBe7lOtnwOHheUk60v2H2fen_WXJp6onYI';
// eslint-disable-next-line no-useless-escape
export const EMAIL_REGULAR_EXPRESSION = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const DOCUMENT_NUMBER_EXPRESSION = /^(?!.*[\W_])(?=.{3,24}$).*/;
export const AuthOClientId = 'MGH3FtNf9MjkWxUnQCSHdFeeOCgm3V5h';
export const AuthODomain = 'auth.travelwits.com';
export const AuthOAudience = 'https://dev-a10sne1z.auth0.com/api/v2/';

export const doUseAuth0UniversalLogin = true;

export const DictionaryOfRefundableDepositKeyPhrases = {
  refundable: ['refundable', 'refund', 'ref deposit'],
  nonRefundable: [
    'non- refundable',
    'non refundable',
    'not refundable',
    'non-refundable',
    'nonrefundable',
    'no refund',
    'not: refundable',
    'dep is non-ref',
    'non-ref',
  ],
};

export const refundableStatuses = {
  NO_INFO: 'noInfo',
  REFUNDABLE: 'refundable',
  NON_REFUNDABLE: 'nonRefundable',
};

export const RefundableStatusLabels = {
  [refundableStatuses.NO_INFO]: 'Please see rate rules for refundability or deposit info',
  [refundableStatuses.REFUNDABLE]: 'Refundable deposit (see rate rules for terms and conditions)',
  [refundableStatuses.NON_REFUNDABLE]: 'Non-refundable deposit (see rate rules for terms and conditions)',
};

export const RangeYearsForSearching = {
  AGO_YEARS: 3,
  AHEAD_YEARS: 3,
};

export const AgentTipTypes = {
  AlternativeAirport: 0,
  AlternativeFlightDate: 1,
  AlternativeCruiseDate: 2,
  HotelDealAlert: 3,
  PricePrediction: 4,
  NotSet: 5,
};

export const callbackStatuses = {
  NOT_STARTED: 0,
  FAILURE: 1,
  CONNECTING: 2,
  ON_HOLD: 3,
};

export const doEnableAgentTips = false;

export const labelForEmptyFlightOrigin = {
  flightOrigin: 'Flight Origin',
  flightDestination: 'Flight Destination',
};
export const TravelWitsContentBaseUrl = 'https://travelwitscontent.com';

export const NoHotelImgSrc = 'https://travelwitsimages.s3.amazonaws.com/hotel-not-found-icon.png';
export const NoCarImgSrc = 'https://travelwitsimages.s3.amazonaws.com/no_car_img.png';
export const MaxRentalCarsInTrip = 2;
export const MaxHotelsInTrip = 12;

export const webSocketEventName = {
  SendTips: 'SendTips',
  HotelsUpdated: 'HotelsUpdated',
  FlightsUpdated: 'FlightsUpdated',
};

export const amountParts = {
  initial: 4,
};

// Note: If updating this object, it require update in backend config as well
export const AllowedItineraryModesToHold = [
  TravelTypes.cruise,
  TravelTypes.flight,
];

export const PaymentTypeCodes = {
  DEPOSIT: 0,
  GUARANTEE: 1,
  PREPAY: 2,
  LATE: 3,
};
export const formatPaymentType = (paymentCode) => {
  if (paymentCode === PaymentTypeCodes.DEPOSIT) return 'Deposit Required';
  if (paymentCode === PaymentTypeCodes.GUARANTEE) return 'Guarantee Required';
  if (paymentCode === PaymentTypeCodes.LATE) return 'Guarantee Late Arrival';
  return '';
};

export const COUNTER_LOCATIONS = {
  NON_AIRPORT_LOCATION: 'N',
  IN_TERMINAL: 'I',
  OFF_AIRPORT_RENTAL_SHUTTLE: 'F',
  IN_TERMINAL_RENTAL_SHUTTLE: 'S',
  ON_AIRPORT_RENTAL_SHUTTLE: 'O',
  ON_AIRPORT_AIRPORT_SHUTTLE: 'A',
  CALL_FOR_SHUTTLE: 'C',
  TWO_SHUTTLES_AIRPORT_AND_RENTAL: 'M',
};

export const PageLinks = {
  Login: {
    pageName: 'login',
    url: '/login',
  },
  Home: {
    url: '/',
  },
  Trips: {
    url: '/trips',
  },
  Result: {
    url: '/',
  },
  Compare: {
    url: '/compare',
  },
  Brochure: {
    url: '/brochure',
  },
  DedicatedHotelPage: {
    route: '/hotel/[id]/[name]',
  },
  EmailVerification: {
    pageName: 'emailVerification',
    url: '/emailVerification',
  },
  AddFlight: {
    url: 'search/addflight',
    pageName: 'addflight',
    searchPageSubheading: 'Select a flight that you want added to your existing trip booking.',
    checkoutPageSubheading: 'This flight will be booked and added to your existing trip booking.',
  },
  ChangeFlight: {
    url: 'search/changeflight',
    pageName: 'changeflight',
    searchPageSubheading: 'Select a new flight to replace the flight on your existing trip booking (change/cancellation fees may apply).',
    checkoutPageSubheading: 'This flight will be booked, added to your existing trip booking, while the previously booked flight will be cancelled (change/cancellation fees may apply).',
  },
  AddHotel: {
    url: 'search/addhotel',
    pageName: 'addhotel',
    searchPageSubheading: 'Select a hotel that you want added to your existing trip booking.',
    checkoutPageSubheading: 'This hotel will be booked and added to your existing trip booking.',
  },
  ChangeHotel: {
    url: 'search/changehotel',
    pageName: 'changehotel',
    searchPageSubheading: 'Select a new hotel to replace the hotel on your existing trip booking (change/cancellation fees may apply).',
    checkoutPageSubheading: 'This hotel will be booked, added to your existing trip booking, while the previously booked hotel will be cancelled (change/cancellation fees may apply).',
  },
  AddCruise: {
    url: 'search/addcruise',
    pageName: 'addcruise',
    searchPageSubheading: 'Select a cruise that you want added to your existing trip booking.',
    checkoutPageSubheading: 'This cruise will be booked and added to your existing trip booking.',
  },
  ChangeCruise: {
    url: 'search/changecruise',
    pageName: 'changecruise',
    searchPageSubheading: 'Select a new cruise to replace the cruise on your existing trip booking (change/cancellation fees may apply).',
    checkoutPageSubheading: 'This cruise will be booked, added to your existing trip booking, while the previously booked cruise will be cancelled (change/cancellation fees may apply).',
  },
  AddCar: {
    url: 'search/addcar',
    pageName: 'addcar',
    searchPageSubheading: 'Select a rental car that you want added to your existing trip booking.',
    checkoutPageSubheading: 'This rental car will be booked and added to your existing trip booking.',
  },
  ChangeCar: {
    url: 'search/changecar',
    pageName: 'changecar',
    searchPageSubheading: 'Select a new rental car to replace the rental car on your existing trip booking (change/cancellation fees may apply).',
    checkoutPageSubheading: 'This rental car will be booked, added to your existing trip booking, while the previously booked rental car will be cancelled (change/cancellation fees may apply).',
  },
  AddTour: {
    url: 'search/addtour',
    pageName: 'addtour',
    searchPageSubheading: 'Select a tour that you want added to your existing trip booking.',
    checkoutPageSubheading: 'This tour will be booked and added to your existing trip booking.',
  },
  ChangeTour: {
    url: 'search/changetour',
    pageName: 'changetour',
    searchPageSubheading: 'Select a new tour to replace the tour on your existing trip booking (change/cancellation fees may apply).',
    checkoutPageSubheading: 'This tour will be booked, added to your existing trip booking, while the previously booked tour will be cancelled (change/cancellation fees may apply).',
  },
};

export const TravelOptionTab = {
  CRUISE: 0,
  FLIGHT: 1,
  HOTEL: 2,
  GROUND: 3,
  TIPS: 4,
  CUSTOM: 5,
  TOUR: 6,
};

export const FlightTimePrerences = [
  { value: '', label: 'Any' },
  { value: '05001159', label: 'Morning (5 AM - 11:59 AM)' },
  { value: '12001759', label: 'Afternoon (12 PM - 5:59 PM)' },
  { value: '18002359', label: 'Evening (6 PM - 11:59 PM)' },
  { value: '00000059', label: '12 AM' },
  { value: '01000159', label: '1 AM' },
  { value: '02000259', label: '2 AM' },
  { value: '03000359', label: '3 AM' },
  { value: '04000459', label: '4 AM' },
  { value: '05000559', label: '5 AM' },
  { value: '06000659', label: '6 AM' },
  { value: '07000759', label: '7 AM' },
  { value: '08000859', label: '8 AM' },
  { value: '09000959', label: '9 AM' },
  { value: '10001059', label: '10 AM' },
  { value: '11001159', label: '11 AM' },
  { value: '12001259', label: '12 PM' },
  { value: '13001359', label: '1 PM' },
  { value: '14001459', label: '2 PM' },
  { value: '15001559', label: '3 PM' },
  { value: '16001659', label: '4 PM' },
  { value: '17001759', label: '5 PM' },
  { value: '18001859', label: '6 PM' },
  { value: '19001959', label: '7 PM' },
  { value: '20002059', label: '8 PM' },
  { value: '21002159', label: '9 PM' },
  { value: '22002259', label: '10 PM' },
  { value: '23002359', label: '11 PM' },
  { value: '00000159', label: '12 AM to 1:59 AM' },
  { value: '02000359', label: '2 AM to 3:59 AM' },
  { value: '04000559', label: '4 AM to 5:59 AM' },
  { value: '06000759', label: '6 AM to 7:59 AM' },
  { value: '08000959', label: '8 AM to 9:59 AM' },
  { value: '10001159', label: '10 AM to 11:59 AM' },
  { value: '12001359', label: '12 PM to 1:59 PM' },
  { value: '14001559', label: '2 PM to 3:59 PM' },
  { value: '16001759', label: '4 PM to 5:59 PM' },
  { value: '18001959', label: '6 PM to 7:59 PM' },
  { value: '20002159', label: '8 PM to 9:59 PM' },
  { value: '22002359', label: '10 PM to 11:59 PM' },
];

export const SecurityInformationTypesLabel = {
  [SecurityInformationTypes.PASSPORT_DOCS]: 'Passport or secondary document (DOCS)',
  [SecurityInformationTypes.VISA_DOCO]: 'Visa (DOCO)',
  [SecurityInformationTypes.SELECT_APIS_TYPE]: 'Select APIS type',
};

export const SecurityInformation = [
  {
    value: SecurityInformationTypes.SELECT_APIS_TYPE,
    label: SecurityInformationTypesLabel[SecurityInformationTypes.SELECT_APIS_TYPE],
  },
  {
    value: SecurityInformationTypes.PASSPORT_DOCS,
    label: SecurityInformationTypesLabel[SecurityInformationTypes.PASSPORT_DOCS],
  },
  {
    value: SecurityInformationTypes.VISA_DOCO,
    label: SecurityInformationTypesLabel[SecurityInformationTypes.VISA_DOCO],
  },
];

export const logoLayoutVariants = {
  LOGO_IMAGE_VARIANT: '0',
  LOGO_IMAGE_TEXT_VARIANT: '1',
  LOGO_IMAGE_VARIANT_CENTERED: '2',
};

export const HomeSearchInputFormVariants = {
  DEFAULT: '0',
  CENTER_ALIGNED: '1',
};

// if any changes, change it in CancellationResponseErrorCodes in
// cruises_backend\SharedModels\Models\Responses.cs as well
export const CancellationResponseErrorCodes = {
  FLIGHT_TICKETED: 'FLIGHT_TICKETED',
};

export const RentalChargeTypes = {
  BaseRateTotal: 'Base Rate Total',
  ApproximateTotalPrice: 'Approximate Total Price',
};

export const seatConfirmedStatusCodes = ['HK', 'KK', 'HD', 'HI'];
export const FlightFareSources = {
  NDC: 'NDC_CONNECTOR',
};

export const ResendEmailTypes = {
  SendBrochure: 'SendBrochure',
  SendCompare: 'SendCompare',
  SendClientCopy: 'SendClientCopy',
  SendAgentCopy: 'SendAgentCopy',
  SendCancallationEmail: 'SendCancallationEmail',
};

export const HotelPreferences = {
  ONLY_AGENT_PREFERRED_HOTEL: 0,
  ONLY_PREFERED_PARTNER_RATES: 1,
  ONLY_COMMISSIONABLE: 2,
  ONLY_AVAILABLE_HOTELS: 3,
  BEST_AVAILABLE_RATES: 4,
  ONLY_REFUNDABLE_RATES: 5,
};

export const SabreRemarkTypesValues = {
  General: 'General',
  Historical: 'Historical',
  AlphaCoded: 'AlphaCoded',
  Hidden: 'Hidden',
  Invoice: 'Invoice',
  ClientAddress: 'ClientAddress',
  Corporate: 'Corporate',
  DeliveryAddress: 'DeliveryAddress',
};

export const SabreRemarkTypes = [
  { value: SabreRemarkTypesValues.General, label: 'General (5)', format: '5{remarkText}' },
  { value: SabreRemarkTypesValues.Historical, label: 'Historical (5H-)', format: '5H-{remarkText}' },
  { value: SabreRemarkTypesValues.AlphaCoded, label: 'Alpha-Coded (5{code}¥)', format: '5{code}¥{remarkText}' },
  { value: SabreRemarkTypesValues.Hidden, label: 'Hidden (5HR-)', format: '5HR-{remarkText}' },
  { value: SabreRemarkTypesValues.Invoice, label: 'Invoice (5.)', format: '5.{remarkText}' },
  { value: SabreRemarkTypesValues.ClientAddress, label: 'Client Address (5/)', format: '5/{remarkText}' },
  { value: SabreRemarkTypesValues.Corporate, label: 'Corporate (5C-CORP)', format: '5C-CORP{remarkText}' },
  { value: SabreRemarkTypesValues.DeliveryAddress, label: 'Delivery Address (5DL-)', format: '5DL-{remarkText}' },
];

export const TravelPolicyActions = {
  Deny: 0,
  RequiresApproval: 1,
  ShowMessageAndAllowBook: 2,
};

export const TravelPolicyPolicies = {
  TotalAmount: 0,
  NumberOfNights: 1,
  HotelNightlyRateThreshold: 2,
  RoundTripFlightRateThreshold: 3,
  HotelRateCode: 4,
  BookingLeadDays: 5,
};

// When making change here, Also make change to CheckoutField class,
// in cruises_backend\SharedModels\Models\Business\Users\CheckoutField.cs file in backend.
export const checkoutCustomBookingsFieldTypes = {
  tracking: 'Tracking',
  remark: 'Remark',
};

/**
 * log text to the console in custom format. https://gyazo.com/8246953e0143013f6b3c4b9fd3b1bd9f
 * Designed to stand out from other logs so we can easily find out.
 * @param {string} text - The text to log.
 */

export const logErrorToConsole = (...args) => {
  // eslint-disable-next-line no-console
  console.log(
    '%cERROR: ',
    'background: red; border-radius: 5px; color: white; padding: 3px 6px;',
    ...args,
  );
};

export const userLocalPreferencesKey = 'userLocalPreferences';

export const userLocalPreferencesSchema = [
  { key: 'doHideAgentCommission', label: 'Hide Commission' },
];

export const UUID_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const isUUID = (str) => UUID_REGEX.test(str);

export const STATIC_TRIP_ID = '00000000-0000-0000-0000-000000000000';

export const InitialFormValidations = {
  flightSegments: [],
};

export const HotelProviders = {
  SABRE_LODGING: 'sabreLodging',
  TABLET: 'tablet',
  HOTELBEDS: 'hotelbeds',
};

export const HotelProvidersLabels = {
  [HotelProviders.SABRE_LODGING]: 'Sabre',
  [HotelProviders.TABLET]: 'Tablet',
  [HotelProviders.HOTELBEDS]: 'Hotelbeds',
};

// https://stackoverflow.com/questions/4603289/how-to-detect-that-javascript-and-or-cookies-are-disabled
export const areCookiesEnabled = () => {
  try {
    if (navigator?.cookieEnabled) return true;

    document.cookie = 'cookietest=1; SameSite=Strict; path=/';
    const cookiesEnabled = document.cookie.indexOf('cookietest=') !== -1;
    document.cookie = 'cookietest=1; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    return cookiesEnabled;
  } catch (error) {
    logErrorToConsole('Error checking cookies enabled', error);
    return false;
  }
};

// Generic try-catch wrapper for non-critical operations (e.g., tracking woopra events etc)
// Ensures failures (null/undefined access, etc.) don’t break the app.
export const tryCatchWrapper = (fn) => async (...args) => {
  try {
    return fn(...args);
  } catch (error) {
    logErrorToConsole(error);
    return undefined;
  }
};

export const ICONS_BASE = 'https://travelwitsimages.s3.amazonaws.com/icons';

export const placementOptions = {
  TOP: 'Top',
  TOP_BANNER: 'TopBanner',
  BELOW_SEARCHBAR: 'BelowSearchBar',
  DASHBOARD: 'Dashboard',
};
